import React, { Component } from 'react'
import { PropTypes } from 'prop-types'
import Webcam from 'webcamjs'
import 'webcamjs/webcam.swf'
import { connect } from 'react-redux'
import { hideWebcamModal } from '../../state/actions/stepActions'
import { uploadFile } from '../../state/actions/componentsActions'
import Button from '../button'
import { CONTEXT_ROOT, resizeImage, MAX_IMAGE_UPLOAD_SIZE } from '../../utils'

import { css, withStyles } from '../../styles/withStyles'
import Styles from './styles'

class WebcamModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      value: props.component.value,
      showWebcam: false
    }

    Webcam.set({
      // 'force_flash': true,
      swfURL: `${CONTEXT_ROOT}/assets/webcam.swf`
    })
  }

  componentWillMount() {
    if (
      !this.props.component.value &&
      this.props.component.uploadType === 'SELFIE'
    ) {
      this.showWebcam()
    }
  }

  screenshot() {
    const that = this
    Webcam.snap(dataUri => {
      that.setState({ value: dataUri })
      if (
        !!document.getElementById('my_camera') &&
        document.getElementById('my_camera').childNodes[1].tagName === 'VIDEO'
      ) {
        Webcam.reset()
      }
    })
  }

  showWebcam() {
    this.setState({ showWebcam: true })
    setTimeout(() => Webcam.attach('#my_camera'), 100)
  }

  showUploader() {
    const { dispatch, component } = this.props
    dispatch(hideWebcamModal())
    document.getElementById(`${component.id}--out`).click()
  }

  closePopup(/*e*/) {
    const { dispatch } = this.props
    if (
      !!document.getElementById('my_camera') &&
      document.getElementById('my_camera').childNodes[1].tagName === 'VIDEO'
    ) {
      Webcam.reset()
    }
    dispatch(hideWebcamModal())
  }

  onCancel() {
    this.setState({
      value: null
    })
    this.showWebcam()
  }

  onAccept() {
    const { component, dispatch } = this.props

    if (!!this.state.value) {
      if (this.state.value !== component.value) {
        resizeImage(this.state.value, MAX_IMAGE_UPLOAD_SIZE).then(dataUri => {
          const time = new Date().getTime()
          dispatch(
            uploadFile(
              { ...component, value: dataUri },
              { name: 'captured_' + time + '.jpg' }
            )
          )
        })
      }

      dispatch(hideWebcamModal())
    }
  }

  render() {
    return (
      <div
        {...css(
          this.props.styles.modal,
          this.props.component.status.indexOf('hidden') > -1 &&
            this.props.styles['modal--hidden']
        )}
      >
        <div {...css(this.props.styles.bg)} />
        <div
          {...css(this.props.styles.closeBtn)}
          onClick={this.closePopup.bind(this)}
        />
        <div {...css(this.props.styles.wrapper)}>
          <div
            {...css(
              this.props.styles.content,
              this.props.styles['content--selfie']
            )}
          >
            <h1 {...css(this.props.styles.title)}>
              {this.props.component.modalTitle}
            </h1>
            {!this.state.value && this.state.showWebcam ? (
              <div
                id="my_camera"
                style={{
                  height: Math.ceil(window.innerHeight / 2),
                  width: Math.ceil(4 * window.innerHeight / 2 / 3),
                  marginLeft: 'auto',
                  marginRight: 'auto',
                  marginTop: '1rem'
                }}
              />
            ) : null}
            {this.state.value ? (
              <img
                ref="screenshot"
                {...css(this.props.styles.screenshot)}
                src={this.state.value}
              />
            ) : null}
            <div {...css(this.props.styles['selfie-buttons'])}>
              {!!this.state.showWebcam && !this.state.value ? (
                <Button
                  type="primary-inverse"
                  action={this.screenshot.bind(this)}
                  text="Scatta"
                />
              ) : null}
              {this.state.value ? (
                <Button
                  type="inverse"
                  action={this.onCancel.bind(this)}
                  text={this.state.showWebcam ? 'Riprova' : 'Webcam'}
                />
              ) : null}
              {this.state.value ? (
                <Button
                  type="primary-inverse"
                  action={this.onAccept.bind(this)}
                  text="Conferma"
                />
              ) : null}
              {!this.state.showWebcam &&
              this.props.component.uploadType !== 'SELFIE' ? (
                <Button
                  type="inverse"
                  action={this.showUploader.bind(this)}
                  text="Sfoglia"
                />
              ) : null}
              {!this.state.showWebcam &&
              !this.state.value &&
              this.props.component.uploadType !== 'SELFIE' ? (
                <Button
                  type="primary-inverse"
                  action={this.showWebcam.bind(this)}
                  text="Webcam"
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
    )
  }
}

WebcamModal.propTypes = {
  component: PropTypes.object.isRequired,
  styles: PropTypes.object.isRequired
}

const mapStateToProps = (state, ownProps) => {
  const { components } = state
  return {
    component: components[ownProps.component.id],
    components
  }
}

export default connect(mapStateToProps)(withStyles(Styles)(WebcamModal))



// WEBPACK FOOTER //
// ./components/webcammodal/index.js